import { registeredTableHandlers } from '@/global/components/view-layouts/tabs-layout/config/registered-table-handlers'
import { api } from '@/global/services/api'

const DEFAULT_EMPTY_VALUE = '--'
export default {
  methods: {
    showEdit (event) {
      this.navigatesToTableDetailsView('TripConfigurationDetails', event, {
        trip_config: event?.data?.description || DEFAULT_EMPTY_VALUE
      })
    },

    onTripConfigDelete (event) {
      const { id, name } = event?.data || {}
      if (!id) {
        return
      }

      const title = this.$t('satellite-tracking/trip_configuration.delete')
      this.$set(this.informationDialogConfig, 'title', title + ' - ' + (name || '/'))
      this.$set(this.informationDialogConfig, 'positiveBtnText', this.$t('base.save'))
      this.$set(this.informationDialogConfig, 'message', this.$t('satellite-tracking/trip_configuration.confirm_delete'))
      this.$set(this.informationDialogConfig, 'callbackFn', () => this.tripConfigDeletionHandler(event))
      this.$set(this.informationDialogConfig, 'openDialog', true)
    },

    async tripConfigDeletionHandler (event) {
      try {
        const { id } = event?.data || {}
        const { fetchData } = registeredTableHandlers?.[this.tableKey] || {}

        await api('satellite-tracking').delete(`trip-configuration/${id}`)

        this.$set(this.informationDialogConfig, 'openDialog', false)
        if (typeof fetchData === 'function') {
          fetchData()
        }
      }
      catch (exception) {
        console.error(exception)
      }
    }
  }
}
